'use client'
import SaveButton from "../SaveButton/SaveButton";
import BuyButton from "../BuyButton/BuyButton";
import "./book-interaction-pill.css"
import ShareButton from "../ShareButton/ShareButton";
import { useState, useRef, useEffect } from "react";
import { BookInterface } from "../../books/types/book";
 import { useIsClient } from "@/hooks/useBrowser";
 import DetailsButton from "../DetailsButton/DetailsButton";
 import { usePathname } from "next/navigation";

  interface Props {
    activeBook: BookInterface | null;
    share_id?: string;
    isSaved: boolean;
    onSave: (workId: string) => void; 
    onUnsave?: (workId: string) => void; 
    allBooks?: BookInterface[]; 
    query?: string;
    collectionId?:string;
    isDetailsOpen?: boolean;
    onToggleDetails?: () => void;
   }
   
export default function  BookInteractionPill({ 
  activeBook,
  share_id,
  isSaved,
  onSave,
  onUnsave,
  allBooks = [], 
  query = '',
  collectionId,
  isDetailsOpen = false,
  onToggleDetails
}: Props) {
  const [openPopout, setOpenPopout] = useState<string | null>(null);
  const pillRef = useRef<HTMLDivElement>(null);
  const isClient = useIsClient()
  const pathname = usePathname();

  const isBookDetailsPage = pathname?.startsWith('/book/');
  const isUserProfilePage = pathname?.startsWith('/user/') || pathname?.startsWith('/profile/');

  useEffect(() => {
    if (!isClient) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        openPopout !== null && 
        pillRef.current && 
        !pillRef.current.contains(event.target as Node)
      ) {
        setOpenPopout(null);
      }
    };

    if (openPopout !== null) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openPopout, isClient]);

  return (
    <div className="action-bar-container">
      <div className="action-bar" ref={pillRef}>
        {!isBookDetailsPage && !isUserProfilePage && onToggleDetails && (
          <DetailsButton
            book={activeBook}
            isDetailsOpen={isDetailsOpen}
            onToggleDetails={onToggleDetails}
          />
        )}
        <SaveButton 
          work_id={activeBook?.work_urn || ''}
          isSaved={activeBook ? isSaved : false}
          onSave={onSave}
          onUnsave={onUnsave}
          openPopout={openPopout} 
          setOpenPopout={setOpenPopout}
          allBooks={allBooks}
          query={query}
collectionId={collectionId}
        />
        <ShareButton 
          share_id={share_id} 
          openPopout={openPopout} 
          setOpenPopout={setOpenPopout} 
          book={activeBook}
        />
        <BuyButton 
          isbn={activeBook?.isbn_13} 
          asid={activeBook?.asin} 
          openPopout={openPopout} 
          setOpenPopout={setOpenPopout}
        />
      </div>
    </div>
  );
}